import { getIconAsBgImage } from '@sportal365/smp-widget-utils';
import { styled } from '../../../../../packages/theme/stitches.config';
import { FC, useContext, useState } from 'react';
import { ConfigContext, SMPText } from '../../../../../packages/ui/dist';
import { PROVIDER_LOGO_WIDTH } from './MultisportDropdowns';

export enum AgeRestrictionDisplay {
  TOOLTIP = 'tooltip',
  VISIBLE = 'visible',
  NONE = 'none',
}

const Container = styled.withConfig({ componentId: 'AgeRestriction', displayName: 'Container' })('div', {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
});

const ImgContainer = styled.withConfig({ componentId: 'AgeRestriction', displayName: 'ImgContainer' })('div', {
  width: '26px',
  height: '26px',
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
});

const Tooltip = styled.withConfig({ componentId: 'AgeRestriction', displayName: 'Tooltip' })('div', {
  backgroundColor: '$borderMultiSportColor',
  color: '$ageRestrictTextColor',
  textAlign: 'center',
  borderRadius: '$2',
  padding: '$1 6px',
  marginLeft: '$6',
  position: 'absolute',
  zIndex: 1,
  fontSize: '8px',
  fontWeight: 600,
  lineHeight: '10px',
  minWidth: '82px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  '&::before': {
    content: '""',
    position: 'absolute',
    right: '100%',
    top: '50%',
    transform: 'translateY(-50%)',
    borderWidth: '5px',
    borderStyle: 'solid',
    borderColor: 'transparent $gray3 transparent transparent',
  },
});

interface Props {
  text: string;
}

const AgeRestriction: FC<Props> = ({ text }) => {
  const [isHovered, setIsHovered] = useState(false);
  const { dataAgeRestrictionDisplay, dataTheme } = useContext(ConfigContext);

  if (dataAgeRestrictionDisplay === AgeRestrictionDisplay.TOOLTIP) {
    return (
      <Container onPointerOver={() => setIsHovered(true)} onPointerLeave={() => setIsHovered(false)}>
        <ImgContainer
          style={{
            backgroundImage: `url("${getIconAsBgImage(dataTheme === 'dark' ? 'age_restriction_black' : 'age_restriction_white')}")`,
            color: '$borderMultiSportColor',
          }}
        />
        <Tooltip style={{ display: isHovered ? 'block' : 'none' }}>{text}</Tooltip>
      </Container>
    );
  } else if (dataAgeRestrictionDisplay === AgeRestrictionDisplay.VISIBLE) {
    return (
      <SMPText size='really-small' css={{ width: PROVIDER_LOGO_WIDTH, color: '$ageRestrictTextColor', mt: '$1' }}>
        {text}
      </SMPText>
    );
  } else {
    return null;
  }
};

export default AgeRestriction;
